import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { AdminProfile } from '@/api/types';

interface AuthState {
  token: string | null;
  admin: AdminProfile | null;
  setSession: (token: string, admin: AdminProfile) => void;
  clear: () => void;
}

/**
 * 鉴权 store。token 持久化到 localStorage,刷新页面保持登录。
 * 离开页面 / 401 → clear()。
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      admin: null,
      setSession: (token, admin) => set({ token, admin }),
      clear: () => set({ token: null, admin: null }),
    }),
    {
      name: 'superaios-admin-auth',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
